<!-- @format -->

<sis-expandable
  [title]="(courseUnit.name | localizedString) + ' (' + (courseUnit.credits | creditRange: 'TEXT' : false) + ')'"
  [subTitle]="courseUnit.code"
  [attr.data-cy]="'cu-code-enrolledItem'">
  <ng-template sisExpandableContent>
    <app-product-basic-info [product]="product" [completionMethod]="completionMethod" />
    @if (ready) {
      <app-open-university-enrolled-info
        [assessmentItemsData]="assessmentItemsData"
        [openUniStudentEnrolments]="openUniStudentEnrolments" />
    }
  </ng-template>
</sis-expandable>
